package com.shadowings.gero.data.lessons.chapter10

import com.shadowings.gero.data.lessons.chapter3.getGenitivoDiretto2QuizContent
import com.shadowings.gero.data.lessons.chapter3.getListeNomiQuizContent
import com.shadowings.gero.data.lessons.chapter4.getGenitivoIndiretto2QuizContent
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_il_genitivo_indiretto_1
import gero.composeapp.generated.resources.exp_content_il_genitivo_indiretto_2
import gero.composeapp.generated.resources.exp_content_il_genitivo_indiretto_3
import gero.composeapp.generated.resources.exp_content_il_genitivo_indiretto_4
import gero.composeapp.generated.resources.exp_title_il_genitivo_indiretto

fun getIlGenitivoIndirettoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_il_genitivo_indiretto,
            content = Res.string.exp_content_il_genitivo_indiretto_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_genitivo_indiretto,
            content = Res.string.exp_content_il_genitivo_indiretto_2,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_genitivo_indiretto,
            content = Res.string.exp_content_il_genitivo_indiretto_3,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_il_genitivo_indiretto,
            content = Res.string.exp_content_il_genitivo_indiretto_4,
            face = Faces.Sad,
            character = Characters.Nilo,
        )
    )
}

fun getIlGenitivoIndirettoQuizContent(
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return (
        getGenitivoDiretto2QuizContent(words = words, languageCode = languageCode).shuffled().take(4)
            + getGenitivoIndiretto2QuizContent(words = words, languageCode = languageCode).shuffled().take(4)
            + getListeNomiQuizContent(words = words, languageCode = languageCode).shuffled().take(4)
    )
}
